// @flow
import { fork } from 'redux-saga/effects';
import getResultsSaga from './getResults';

export default function* resultsSaga() {
  yield fork(getResultsSaga);
}
